import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';
import { DatePickerField } from 'Common/SemanticWrapper';

import { UN_APPLY_CYCLE_MENU_FORM_NAME } from 'Common/FormEnum';
import { UnApplyCycleMenuFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import { SelectSitesTableReduxForm } from 'Common/SelectSitesTableReduxForm';
import { rangeDateValidator } from 'Common/FormHelper';

const UnApplyCycleMenuFormContainer = ({ sites, additionalColumns }) => (
  <Form name={UN_APPLY_CYCLE_MENU_FORM_NAME}>
    <TitledCard title="Date Range" tight>
      <Grid padded={false}>
        <Grid.Row>
          <Grid.Column width={4}>
            <Field
              name={Fields.StartDateTime}
              label="From"
              component={DatePickerField}
              placeholder="Select a date"
              hideEmptyError
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Field
              name={Fields.EndDateTime}
              label="To"
              component={DatePickerField}
              placeholder="Select a date"
              hideEmptyError
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </TitledCard>
    <TitledCard title="Sites" tight>
      <Field
        name={Fields.SiteIds}
        component={SelectSitesTableReduxForm}
        fetchSites={false}
        sites={sites}
        additionalColumns={additionalColumns}
        className="unapply-react-table"
      />
    </TitledCard>
  </Form>
);

const validate = (values) => {
  const errors = {};

  if (!values[Fields.StartDay]) {
    errors[Fields.StartDay] = 'Begin with Cycle Day Required';
  } else {
    if (Number(values[Fields.StartDay]) <= 0) {
      errors[Fields.StartDay] =
        'Begin with Cycle Day must be greater than zero.';
    }
    if (Number(values[Fields.StartDay]) > values[Fields.NumberOfDaysInCycle]) {
      errors[Fields.StartDay] =
        'Begin with Cycle Day cannot exceed ' +
        values[Fields.NumberOfDaysInCycle] +
        '.';
    }
  }

  const dateErrors = rangeDateValidator(
    values[Fields.StartDateTime],
    values[Fields.EndDateTime],
    {
      granularity: 'day',
      fromName: Fields.StartDateTime,
      toName: Fields.EndDateTime,
      fromLabel: 'From',
      toLabel: 'To',
    }
  );

  if (
    !Array.isArray(values[Fields.SiteIds]) ||
    values[Fields.SiteIds].length < 1
  ) {
    errors[Fields.SiteIds] = 'Please select a site or site group';
  }

  return {
    ...dateErrors,
    ...errors,
  };
};

const UnApplyCycleMenuForm = reduxForm({
  form: UN_APPLY_CYCLE_MENU_FORM_NAME,
  validate,
})(UnApplyCycleMenuFormContainer);

export { UnApplyCycleMenuForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/UnApplyCycleMenuForm.js